import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cash-conversion-cycle-calculator',
  component: () => import('../../routes/CashConversionCycleCalculator.svelte'),
  card: {
    id: 'cash-conversion-cycle',
    title: 'Cash Conversion Cycle Calculator',
    description:
      'Calculate how many days it takes to convert inventory investments into cash from sales. Measures working capital efficiency.',
    icon: 'cycle',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/cash-conversion-cycle-calculator',
    category: 'Business',
  },
  seo: {
    title: 'Cash Conversion Cycle Calculator – Free Working Capital Efficiency Tool',
    description:
      'Free cash conversion cycle calculator. Calculate DSO, DIO, and DPO to measure how efficiently a company converts its working capital into cash.',
  },
};

export default meta;